/**
 * @file: util.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { DeliveryCheckSceneType } from '@euler/model/enum';
import { DeliveryCheckItemStaged } from '@euler/model/task-detail';
import { isNotNull } from '@euler/utils';

export type DeliveryCheckItemError =
  | 'item-not-checked'
  | 'item-medias-required'
  | 'unexpected-option';

export type InvalidDeliveryCheckItemHandler = (args: {
  item: DeliveryCheckItemStaged;
  index: number;
  error: DeliveryCheckItemError;
  message: string;
}) => void;

export const validateDeliveryCheckItem = (
  sceneType: DeliveryCheckSceneType,
  item: DeliveryCheckItemStaged,
): { type: DeliveryCheckItemError; message: string } | undefined => {
  if (item.selectedOptionIndex == null || item.selectedOptionIndex < 0) {
    return { type: 'item-not-checked', message: '请选择该项检查结果选项!' };
  }
  if (item.requiresPhoto && item.medias.length === 0) {
    return {
      type: 'item-medias-required',
      message: '请选择或拍摄该项检查结果相关的照片或者视频',
    };
  }

  const expectedOptionIndexes = new Set(
    item.options
      .map((x, i) => (x.isExpected ? i : undefined))
      .filter(isNotNull),
  );

  if (expectedOptionIndexes.has(item.selectedOptionIndex)) {
    return undefined;
  }

  if (
    sceneType === DeliveryCheckSceneType.CompletionCheck &&
    !item.unacceptedReason?.trim()
  ) {
    return {
      type: 'unexpected-option',
      message: '必须选择或填写检验未通过原因!',
    };
  }

  return undefined;
};
